import { Route } from 'react-router-dom';
import OrderClosed from '../pages/orderClosed/OrderClosed';

const OrderClosedRoute = ({ ...rest }) => (
	<Route {...rest} render={(props) => <OrderClosed />} />
);

export default OrderClosedRoute;
